// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteEmployeeModal_overlay__mSaS0 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.DeleteEmployeeModal_modal__ArHoJ {
  background: #fff;
  border-radius: 12px;
  padding: 36px 32px;
  width: 100%;
  max-width: 420px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.DeleteEmployeeModal_iconWrapper__7PYD\\+ {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.DeleteEmployeeModal_warningIcon__4eA7E {
  width: 52px;
  height: 52px;
  color: #e53e3e;
}

.DeleteEmployeeModal_title__br8JO {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px;
}

.DeleteEmployeeModal_message__qTSW1 {
  font-size: 0.95rem;
  color: #4a5568;
  margin: 0 0 6px;
  line-height: 1.6;
}

.DeleteEmployeeModal_subMessage__3rAxh {
  font-size: 0.85rem;
  color: #e53e3e;
  margin: 0 0 28px;
}

.DeleteEmployeeModal_actions__dFycc {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.DeleteEmployeeModal_cancelBtn__qkW3h {
  padding: 10px 24px;
  border-radius: 8px;
  border: 1px solid #cbd5e0;
  background: #fff;
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.DeleteEmployeeModal_cancelBtn__qkW3h:hover {
  background: #f7fafc;
  border-color: #a0aec0;
}

.DeleteEmployeeModal_deleteBtn__Ej0E5 {
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  background: #e53e3e;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.DeleteEmployeeModal_deleteBtn__Ej0E5:hover {
  background: #c53030;
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Employee Master/EmployeeList/DeleteEmployeeModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 36px 32px;\n  width: 100%;\n  max-width: 420px;\n  text-align: center;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n}\n\n.iconWrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.warningIcon {\n  width: 52px;\n  height: 52px;\n  color: #e53e3e;\n}\n\n.title {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 12px;\n}\n\n.message {\n  font-size: 0.95rem;\n  color: #4a5568;\n  margin: 0 0 6px;\n  line-height: 1.6;\n}\n\n.subMessage {\n  font-size: 0.85rem;\n  color: #e53e3e;\n  margin: 0 0 28px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.cancelBtn {\n  padding: 10px 24px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e0;\n  background: #fff;\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.cancelBtn:hover {\n  background: #f7fafc;\n  border-color: #a0aec0;\n}\n\n.deleteBtn {\n  padding: 10px 24px;\n  border-radius: 8px;\n  border: none;\n  background: #e53e3e;\n  color: #fff;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.deleteBtn:hover {\n  background: #c53030;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `DeleteEmployeeModal_overlay__mSaS0`,
	"modal": `DeleteEmployeeModal_modal__ArHoJ`,
	"iconWrapper": `DeleteEmployeeModal_iconWrapper__7PYD+`,
	"warningIcon": `DeleteEmployeeModal_warningIcon__4eA7E`,
	"title": `DeleteEmployeeModal_title__br8JO`,
	"message": `DeleteEmployeeModal_message__qTSW1`,
	"subMessage": `DeleteEmployeeModal_subMessage__3rAxh`,
	"actions": `DeleteEmployeeModal_actions__dFycc`,
	"cancelBtn": `DeleteEmployeeModal_cancelBtn__qkW3h`,
	"deleteBtn": `DeleteEmployeeModal_deleteBtn__Ej0E5`
};
export default ___CSS_LOADER_EXPORT___;
